module.exports = __webpack_public_path__ + "Flama-Medium.ttf?96c3b02848c71fbb77171a1ffbf6468e";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-Medium.ttf
// module id = 916
// module chunks = 0